import EmbeddedReport from './embedded-report'
import type { RouteObject } from 'react-router-dom'

export const PowerBIRoute: RouteObject = {
    path: '/power-bi',
    element: <EmbeddedReport />,
}
